import { Divider, DividerProps } from 'antd'

export default function CustomDivider(props: DividerProps) {
  return <Divider className="my-[15px]" {...props} />
}
import { Divider, DividerProps } from 'antd'

export default function CustomDivider(props: DividerProps) {
  return <Divider className="my-[15px]" {...props} />
}
